import { Link } from "react-router-dom";

/**
 * Brand wordmark: RE//FORM PLACE CHI
 * The signature "//" is always colored with the brand red.
 */
export function BrandMark({ size = "md", className = "" }) {
  const sizeCls = {
    sm: "text-lg tracking-tight",
    md: "text-xl md:text-2xl tracking-tight",
    lg: "text-3xl md:text-4xl tracking-tight",
  }[size];
  return (
    <Link
      to="/"
      data-testid="brand-mark"
      className={`font-display font-black uppercase text-white ${sizeCls} ${className}`}
      aria-label="RE FORM PLACE CHI Home"
    >
      RE
      <span className="brand-red">//</span>
      FORM <span className="brand-red">PLACE</span> CHI
    </Link>
  );
}

export function BrandMarkStatic({ className = "" }) {
  return (
    <span
      data-testid="brand-mark-static"
      className={`font-display font-black uppercase text-white ${className}`}
    >
      RE<span className="brand-red">//</span>FORM{" "}
      <span className="brand-red">PLACE</span> CHI
    </span>
  );
}
